/**
 * 規約同意ゲート（ブロッキング・インタースティシャル）
 *
 * 認証済みかつ未同意（needsConsent）のユーザーに対し、本体描画を完全に覆って
 * 「同意する」か「ログアウト」かの二択を迫る。dismissible なモーダルにはしない
 * （×/あとで を置かない・裏は操作不能）。計画書 Step B3。
 *
 * - 利用規約／プライバシーポリシーは独立した 2 チェックボックス（unbundled）。
 *   両方 ON で初めて「はじめる」が活性。初期は両方 OFF（プリチェック禁止）。
 * - 「はじめる」→ POST /api/auth/consent（成功時のみ onConsented で遮断解除）。
 *   失敗時はゲートに留まりリトライ可能（未記録のまま本体に入れない）。
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/babak-lp.css';
import './ConsentGate.css';

export default function ConsentGate({ onConsented, onLogout }) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
  const [agreedTerms, setAgreedTerms] = useState(false);
  const [agreedPrivacy, setAgreedPrivacy] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const canSubmit = agreedTerms && agreedPrivacy && !submitting;

  const handleAgree = async () => {
    if (!canSubmit) return;
    setSubmitting(true);
    setError('');
    try {
      const res = await fetch(`${backendUrl}/api/auth/consent`, {
        method: 'POST',
        credentials: 'include',
      });
      if (!res.ok) throw new Error(`status ${res.status}`);
      onConsented();
    } catch {
      setError('同意の記録に失敗しました。通信環境をご確認のうえ、もう一度お試しください。');
      setSubmitting(false);
    }
  };

  return (
    <div
      className="babak-lp consent-gate"
      role="dialog"
      aria-modal="true"
      aria-labelledby="consent-title"
    >
      <div className="consent-card">
        <h1 id="consent-title" className="consent-title">ご利用の前に</h1>
        <p className="consent-lede">Babak をはじめる前に、下記にご同意ください。</p>

        <div className="consent-checks">
          <label className="consent-check">
            <input
              type="checkbox"
              checked={agreedTerms}
              onChange={(e) => setAgreedTerms(e.target.checked)}
              disabled={submitting}
            />
            <span>
              <Link to="/terms" target="_blank" rel="noopener noreferrer">利用規約</Link> に同意します
            </span>
          </label>
          <label className="consent-check">
            <input
              type="checkbox"
              checked={agreedPrivacy}
              onChange={(e) => setAgreedPrivacy(e.target.checked)}
              disabled={submitting}
            />
            <span>
              <Link to="/privacy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</Link> に同意します
            </span>
          </label>
        </div>

        {error && <div className="consent-error" role="alert">{error}</div>}

        <button className="consent-btn" onClick={handleAgree} disabled={!canSubmit}>
          {submitting ? '記録中…' : 'はじめる'}
        </button>

        <button className="consent-logout" onClick={onLogout} disabled={submitting}>
          ログアウト
        </button>
      </div>
    </div>
  );
}
